import React from "react";

const ASP_Quick_Ref = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Quick Ref</h1>
      <p>This is the ASP Quick Ref page content.</p>
    </div>
  );
};

export default ASP_Quick_Ref;
